/**
 * The devices and browsers signed in to your account: when each signed in and was last used,
 * how, and when it ends by itself; sign one out, or every other one.
 */
import { For, Show, createResource, type JSX } from "solid-js";
import { toast } from "../shared/toast";
import { formatDate } from "../shared/ui";
import { usePages } from "./context";

/** The words for how a session signed in. */
const VIA: Record<string, string> = { password: "password", google: "Google", github: "GitHub" };

/** The devices section. */
export function AccountSessions(): JSX.Element {
  const { accounts, server } = usePages();
  const [sessions, { refetch }] = createResource(() => accounts.call(server, (a) => a.sessions(), true));
  const end = async (id: string) => {
    await accounts.call(server, (a) => a.endSession(id));
    void refetch();
  };
  const others = async () => {
    const done = await accounts.call(server, (a) => a.signOutOthers());
    if (done) toast(done.ended ? `Signed out ${done.ended} other device${done.ended === 1 ? "" : "s"}.` : "No other device was signed in.");
    void refetch();
  };
  return (
    <section class="team-section" id="account-sessions">
      <h3>Signed-in devices</h3>
      <ul class="member-list">
        <For each={sessions() ?? []}>
          {(s) => (
            <li data-session={s.id} data-session-current={s.current ? "yes" : "no"}>
              <span class="member-name">
                <b>{s.current ? "This browser" : `Signed in ${formatDate(s.created)}`}</b>
                <span class="muted small">
                  with {VIA[s.via] ?? s.via} · last used {formatDate(s.seen)} · ends {formatDate(s.expires)} unless used
                </span>
              </span>
              <Show when={!s.current}>
                <button type="button" class="mini" data-session-end onClick={() => void end(s.id)}>
                  Sign out
                </button>
              </Show>
            </li>
          )}
        </For>
      </ul>
      <button type="button" class="btn" id="signout-others" onClick={() => void others()}>
        Sign out everywhere else
      </button>
    </section>
  );
}
